import React from 'react';

import Header from '../../layout/Header.jsx';
import ListArticleStats from '../../lists/ListArticleStats.jsx';

const PageArticleStats = () => (
  <div>
    <Header>Article Statistics</Header>
    <ListArticleStats />
  </div>
);

export default PageArticleStats;
